import { createFileRoute } from "@tanstack/react-router";
import AdminWebSocketsPage from "@/admin/pages/websockets";

export const Route = createFileRoute("/admin/websockets")({
  component: AdminWebSocketsPage,
});
